module.exports = __webpack_public_path__ + "media/country_flags/it-48d6c645.png";